import axiosInstance from './';
import Storage from '../helpers/storage';

export default class {
  constructor() {
    this.instance = axiosInstance();
  }

  getAll() {
    const merchant = Storage.getLocalStorageMerchant();
    return this.instance({
      url: `/menus?merchantId=${merchant.idUnity}`,
    });
  }

  post(data) {
    return this.instance({
      url: '/menus',
      method: 'POST',
      data,
    });
  }

  put(data) {
    return this.instance({
      url: `/menus/${data.id}`,
      method: 'PUT',
      data,
    });
  }

  patch(id, data) {
    return this.instance({
      url: `/menus/${id}`,
      method: 'PATCH',
      data,
    });
  }

  delete(id) {
    return this.instance({
      url: `/menus/${id}`,
      method: 'DELETE',
      data: {},
    });
  }
}



// WEBPACK FOOTER //
// ./src/services/Menu.js